export function preserveCursor(handler) {
    return function (e) {
        const start = e.target.selectionStart;
        const end = e.target.selectionEnd;
        handler(e);
        requestAnimationFrame(() => {
            e.target.selectionStart = start;
            e.target.selectionEnd = end;
        });
    };
}
